import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Badge,
} from 'reactstrap';
import moment from 'moment';
import useModal from '../../../shared/hooks/useModal';
import Api from '../../../util/api';
import DeleteModal from '../../../shared/components/custom/DeleteModal';
import skeletonTableLoader from '../../../shared/components/custom/SkeletonLoaders';
import t, { partial } from '../../../util/translation/translation';

import ViewIcon from 'mdi-react/EyeIcon';
import EditIcon from 'mdi-react/CommentOutlineIcon';

const QuestionaireListPage = ({ setLoading }) => {
  const [questionaires, setQuestionaires] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 10,
  });
  const [order, setOrder] = useState({
    orderBy: 'createdAt',
    desc: true,
  });
  const p = partial('questionaire');
  const s = partial('shared');

  const fetchQuestionaires = async (
    currentPage = 1,
    pageSize = 3,
    orderObject = {
      orderBy: 'createdAt',
      desc: true,
    }
  ) => {
    setLoading(true);
    try {
      const reqQuestionaires = await Api.questionaire.getQuestionaires(
        { page: currentPage, take: pageSize },
        {
          orderBy: orderObject.orderBy,
          direction: orderObject.desc ? 'DESC' : 'ASC',
        }
      );
      setQuestionaires(reqQuestionaires.data);
      setPagination((old) => ({ ...old, total: reqQuestionaires.count }));
      setLoading(false);
      const questionaireIds = reqQuestionaires.data.map((item) => item.id);
      const { data: viewsData } =
        await Api.questionaire.getQuestionairesViewAmount({ questionaireIds });
      const mapped = reqQuestionaires.data.map((item) => ({
        ...item,
        views:
          viewsData.find((itemView) => itemView.itemId === item.id)?.views || 0,
      }));
      setQuestionaires(mapped);
    } catch (err) {
      toast.error(p('failedToFetchQuestionaires'));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchQuestionaires();
  }, []);
  const deleteQuestionaire = async () => {
    setLoading(true);
    try {
      await Api.questionaire.deleteQuestionaire(deleteID);
      toast.success(p('questionaireDeleted'));
    } catch (err) {
      toast.error(p('questionaireDeleteError'));
    } finally {
      handleModal();
      fetchQuestionaires(pagination.currentPage, pagination.perPage, order);
    }
  };

  const getBadgeStatus = (questionaire) => {
    if (!questionaire.visible) {
      return {
        color: 'danger',
        text: s('inActive'),
      };
    }
    if (moment().isAfter(moment(questionaire.endDate))) {
      return {
        color: 'secondary',
        text: s('closed'),
      };
    }
    if (moment().isBefore(moment(questionaire.startDate))) {
      return {
        color: 'warning',
        text: s('scheduled'),
      };
    }
    return {
      color: 'success',
      text: s('active'),
    };
  };

  const renderQuestionaires = () => {
    return questionaires.map((questionaire, i) => {
      const badge = getBadgeStatus(questionaire);
      return (
        <Link
          to={`/questionnaires/edit/${questionaire.id}`}
          iv
          className="flex flex-column justify-start mb-2 hover-link"
        >
          <div
            className="flex flex-row space-between"
            style={{ marginBottom: 11 }}
          >
            <span style={{ color: '#121B2B', fontWeight: 500, fontSize: 18 }}>
              {questionaire.title}
            </span>
            {/*<UncontrolledDropdown className="dashboard__table-more">
              <DropdownToggle>
                <DotsHorizontalIcon />
              </DropdownToggle>
              <DropdownMenu className="dropdown__menu">
                <Link to={`/questionnaires/edit/${questionaire.id}`}>
                  <DropdownItem>{s('edit')}</DropdownItem>
                </Link>
                <Link to={`/questionnaires/clone/${questionaire.id}`}>
                  <DropdownItem>{s('clone')}</DropdownItem>
                </Link>
                <DropdownItem
                  onClick={() => handleModal(questionaire.id)}
                  className="danger"
                >
                  {s('delete')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>*/}
            <div>
              <Badge color={badge.color}>{badge.text}</Badge>
            </div>
          </div>
          <div className="flex flex-row space-between">
            <div>
              <span
                style={{
                  fontSize: 14,
                  marginTop: 2,
                  marginRight: 10,
                  color: '#4D576A',
                }}
              >
                {questionaire.views !== undefined ? (
                  <>
                    <ViewIcon
                      size={16}
                      color="#4D576A"
                      style={{ marginTop: -2, marginRight: 2 }}
                    />
                    {questionaire.views}
                  </>
                ) : (
                  skeletonTableLoader(1, 1, 10)
                )}
              </span>
              <span style={{ fontSize: 14, marginTop: 2, color: '#4D576A' }}>
                <>
                  <EditIcon
                    size={16}
                    color="#4D576A"
                    style={{ marginTop: -2, marginRight: 2 }}
                  />
                  {questionaire.answersCount}
                </>
              </span>
            </div>
          </div>
        </Link>
      );
    });
  };

  return (
    <>
      <DeleteModal
        visible={visible}
        type={p('theQuestionaire')}
        handleModal={handleModal}
        modalAction={deleteQuestionaire}
      />
      {renderQuestionaires()}
    </>
  );
};

export default QuestionaireListPage;
